
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/private-messages/sent",
      function () {
        return require("private-next-pages/private-messages/sent.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/private-messages/sent"])
      });
    }
  